module.exports = __webpack_public_path__ + "static/media/download.ddbdcef9.svg";